import Component from './component.js';

class DialogTrigger extends Component {
    /**
     * @type {import('./modal-dialog.js').default}
     */
    dialog = null;

    constructor() {
        super();
        this.addEventListener('keydown', this.onKeyDown);
        this.addEventListener('click', this.onClick);
    }

    connectedCallback() {
        this.role ??= 'button';
        this.tabIndex = 0;
        this.dialog = document.querySelector(`#${this.dataset.target}`);
        this.dialog.addEventListener('hide', this.onDialogHide.bind(this));
    }

    /**
     * @param {KeyboardEvent} event
     */
    onKeyDown(event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.click();
        }
    }

    onClick() {
        this.dialog.show();
    }

    onDialogHide() {
        this.focus();
    }
}

customElements.define('dialog-trigger', DialogTrigger);
export default DialogTrigger;
